@if (showAiTrialBadge$ | async) {
  <badge
    class="practice-badge"
    [badgeColor]="BadgeColors.SUCCESS"
    [badgeLabel]="getMessageTranslation()">
  </badge>
}
